import {
    Label,
    Spinner,
    Table,
    TableBody,
    TableCell,
    TableCellLayout,
    TableHeader,
    TableHeaderCell,
    TableRow,
    makeStyles,
    shorthands
} from "@fluentui/react-components";
import { Tag, TagGroup } from "@fluentui/react-tags";
import axios from "axios";
import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useEffect, useRef, useState } from "react";
import { useAuthState } from 'react-firebase-hooks/auth';
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "./components/Layout";
import MinimumSpendBreakdown, { classifyTransaction } from "./components/MinimumSpendBreakdown";
import { Base_Url, auth, db } from "./services/firebase";
import StripeProductService from "./services/stripeProductService";
import {
    CheckBoxChecked,
    CheckBoxUnChecked,
    DownArowSVG,
    DownSmallArrow,
    FilterSVG,
    NodataInfoSVG,
    RadioSelected,
    RadioUnSelected
} from "./static/svgs";
import userDataService from "./services/userDataService";
import CustomSearchInput2 from "./components/CustomSearchInput2";
import useBreakpoint from "./hooks/useBreakpoint";
import './components/Forms/FormStyle.css';
import { BookingCategory } from "./Helper";
import { getChargeCardAmount, getMinimumspend, getPointspend, parseIntoDollar } from "./components/OrderHistoryUtil";
import { generateExelData, generateTransactionsData } from "./components/ReportUtil";
import { useDispatch, useSelector } from "react-redux";
import { getMemberList, getStripeProductsList, setMemberList, setStripeProductsList } from "./slices/memberSlice";

// Update columns to match the charges API response
const columns = [
    { columnKey: "source", label: "Source", width: "90px" }, // Stripe / Clover

    { columnKey: "date", label: "Date", width: "150px" },

    { columnKey: "referenceId", label: "Reference", width: "160px" },
    // Invoice number (Stripe) / Order ID (Clover)

    { columnKey: "customer", label: "Customer", width: "180px" },

    { columnKey: "product", label: "Product", width: "220px" },
    // resolved via productId → product list OR fallback text

    { columnKey: "subtotal", label: "Subtotal", width: "100px" },

    { columnKey: "tax", label: "Tax", width: "90px" },

    { columnKey: "total", label: "Total", width: "100px" },

    { columnKey: "status", label: "Status", width: "90px" },
    // Paid / Failed / Partial (derived)

    { columnKey: "billingType", label: "Type", width: "140px" },
    // subscription / manual / POS

    { columnKey: "description", label: "Description", width: "300px" }
];


const invoicecolumns = [
    { columnKey: "isfrom", label: "IsFrom", width: '100px' },
    { columnKey: "total", label: "Total", width: '80px' },
    { columnKey: "invoicesubtotal", label: "Subtotal", width: '80px' },
    { columnKey: "invoiceTax", label: "Invoice Tax", width: '80px' },
    { columnKey: "appliedbalance", label: "Applied balance", width: '100px' },
    { columnKey: "chargeamount", label: "Charge Amount", width: '100px' },
    { columnKey: "status", label: "Status", width: '80px' },
    { columnKey: "description", label: "Description", width: '180px' },
    { columnKey: "created", label: "Date Created", width: '150px' },
    { columnKey: "InvoiceLineItem", label: "Line Item", width: '400px' },
    { columnKey: "OtherInfo", label: "Other Info", width: '300px' },
];

function TransactionsPage() {
    const styles = useStyles();
    const [allCharges, setAllCharges] = useState([]);
    const [finalCalculation, setFinalCalculation] = useState(null);
    const [currentUserId, setUserId] = useState(null); // State to hold Stripe Customer ID
    const navigate = useNavigate();
    const [user, loading, error] = useAuthState(auth);
    const [visibleTags, setVisibleTags] = useState([]);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    const [popupVisibleDate, setPopupVisibleDate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const dateTagRef = useRef(null);
    const breakpoint = useBreakpoint();
    const isMobile = breakpoint === 'mobile';
    const firstTagRef = useRef(null);
    const [dateTags, setDateTags] = useState([]);
    const [exportSelectedOption, setExportSelectedOption] = useState(null);
    const [popupVisibleExport, setPopupVisibleExport] = useState(false);
    // const [stripeProductsList, setStripeProductsList] = useState([]);
    const stripeProductsList = useSelector(getStripeProductsList);
    const dispatch = useDispatch();
    const [stripeTransactionsList, setStripeTransactionsList] = useState([]);
    const [filteredstripeTransactionsList, setFilteredStripeTransactionsList] = useState([]);
    const [members, setMembers] = useState([
        { id: 1, name: 'John', selected: false },
        { id: 2, name: 'Jane', selected: false },
        { id: 3, name: 'Doe', selected: false }
    ]);
    const [dateArray, setDateArray] = useState([]);
    const [searchMembers, setSearchMembers] = useState('');
    const [searchedStripeProduct, setSearchedStripeProduct] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [popupVisible, setPopupVisible] = useState(false);
    const [productsPopupVisible, setProductsPopupVisible] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [memberCreatedDate, setMemberCreatedDate] = useState('');
    const [reportData, setReportData] = useState([]);
    const [hasAccountHolder, setHasAccountHolder] = useState(false);
    const [accountHolderData, setAccountHolderData] = useState(null);
    const [totalRequredSpend, setTotalRequredSpend] = useState(2000);
    const [firebaseProducts, setFirebaseProducts] = useState([]);
    const firebaseProductRef = useRef(new Map());


    useEffect(() => {
        StripeProductService.getAll().then((snapshot) => {
            const list = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setFirebaseProducts(list);
        });
    }, []);

    useEffect(() => {
        if (!firebaseProducts.length) return;
        firebaseProductRef.current = new Map(
            firebaseProducts.map(fp => [fp.productId, fp.isActive])
        );
    }, [firebaseProducts]);


    useEffect(() => {
        fetchUserList()
        if (stripeProductsList.length === 0) {
            fetchProductsList((data) => {
                const productsWithSelection = (data ?? []).map(product => ({
                    ...product,
                    selected: firebaseProductRef.current.get(product.id) ?? true,
                }));
                // setStripeProductsList(productsWithSelection);
                dispatch(setStripeProductsList(productsWithSelection));
            }, (error) => {
                console.log("Fetching Products Error", error);
            })
        }
    }, []);

    //     useEffect(() => {

    //         if (stripeProductsList.length > 0 && firebaseProducts.length > 0) {
    //             const syncedProducts = stripeProductsList.map((product) => {
    //                 const fp = firebaseProducts.find(fp => fp.stripeProductId === product.id);
    //                 return {
    //                     ...product,
    //         selected: fp?.isActive ?? false,
    //       };
    //     });

    //     dispatch(setStripeProductsList(syncedProducts));
    //   }
    // },  [firebaseProducts]);

    useEffect(() => {
        if (!stripeProductsList.length || !firebaseProducts.length) return;

        const syncedProducts = stripeProductsList.map(product => ({
            ...product,
            selected: firebaseProductRef.current.get(product.id) ?? true,
        }));

        dispatch(setStripeProductsList(syncedProducts));
    }, [firebaseProducts]);


    const fetchUserList = async () => {
        try {
            if (!!user) {
                const usersQuery = await userDataService.getAllUser();
                let allUserList = usersQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
                const transformedArray = allUserList.map(obj => ({
                    id: obj.id,
                    name: `${obj.firstName} ${obj.lastName}`.toLocaleLowerCase(),
                    displayname: `${obj.firstName} ${obj.lastName}`,
                    email: obj.email,
                    selected: false,
                    lastBillingCalculationDate: obj.lastBillingCalculationDate.toDate() || new Date(),
                    createdAt: obj.createdAt,
                    Created: obj.Created ? obj.Created : obj.createdAt,
                    accountHolderId: obj.accountHolderId || "",
                    yearlyRequiredSpend: obj.yearlyRequiredSpend || 2000,
                    contractStartDate: obj.contractStartDate || null,
                }));
                setMembers(transformedArray)
            }
        } catch (err) {
            console.error(err);
        }
    };

    const fetchPurchaseData = (startDate, endDate, onSuccess, onError, selectedMember = null) => {
        let uid = (hasAccountHolder && (accountHolderData?.id ?? "") !== "") ? accountHolderData.id : selectedMember.id;

        const formatDateLocal = (dateObj) => {
            if (!(dateObj instanceof Date)) return dateObj;
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const day = String(dateObj.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const config = {
            method: 'get',
            url: `${Base_Url}/stripeApi/getUserStripeAndCloverPurchaseHistory`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${user.accessToken}`,
            },
            params: {
                "userId": uid,
                "startDate": formatDateLocal(startDate),
                "endDate": formatDateLocal(endDate),
                "isProductFilterApply": false
            }
        };
        setIsLoading(true);
        axios.request(config)
            .then((response) => {
                setIsLoading(false);
                const responseData = response.data;
                if ((responseData?.status ?? "") === "success" && (responseData.transactions ?? []).length > 0) {
                    onSuccess(responseData.transactions);
                } else {
                    console.error("No data returned");
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.error("Error fetching data:", err);
                if (onError) onError(err);
            });
    };

    function filterTransactionsByProducts(
        transactions,
        selectedProductIds
    ) {
        // if no filter applied, return full list
        if (!selectedProductIds || selectedProductIds.length === 0) {
            return transactions;
        }

        return transactions.filter(txn => {
            // ---- STRIPE TRANSACTION ----
            if (txn.invoice) {
                const lineItems = txn.invoice.line_items || [];

                // collect valid productIds from line items
                const productIdsInTxn = lineItems
                    .map(item => item.product)
                    .filter(Boolean); // removes empty string / null

                // if NO productId exists → always include
                if (productIdsInTxn.length === 0) {
                    return true;
                }

                // include if ANY productId matches selected list
                return productIdsInTxn.some(pid =>
                    selectedProductIds.includes(pid)
                );
            }

            // ---- CLOVER TRANSACTION ----
            // Clover has no Stripe productId → always include
            return true;
        });
    }


    const fetchProductsList = (onSuccess, onError) => {
        const config = {
            method: 'get',
            url: `${Base_Url}/stripeApi/getAllStripeProducts`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${user.accessToken}`,
            },
        };
        axios.request(config)
            .then((response) => {
                const responseData = response.data;
                if ((responseData.data ?? []).length > 0) {
                    onSuccess(responseData.data);
                } else {
                    console.error("No data returned");
                }
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
                if (onError) onError(err);
            });
    };

    const fetchCharges = (startDate, endDate, selectedMember) => {

        let uid = (hasAccountHolder && (accountHolderData?.id ?? "") !== "") ? accountHolderData.id : selectedMember.id
        setIsLoading(true)
        const config = {
            method: 'get',
            url: `${Base_Url}/stripeApi/getUserStripePurchaseHistory`,
            // url: `http://127.0.0.1:5001/warehouse-prod-40386/us-central1/getUserStripePurchaseHistory`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${user.accessToken}`,
            },
            params: {
                userId: uid,
                startDate: startDate,
                endDate: endDate
            }
        };

        axios.request(config)
            .then((response) => {
                setIsLoading(false)
                if (response.status && response.data && response.data.transactions) {
                    const formattedTransactions = (response.data.transactions || []).map((transaction) => {
                        let invoice = transaction.invoice || {};
                        let charge = transaction.charge || {};
                        let createdDt = invoice.created
                            ? new Date(invoice.created * 1000).toLocaleString()
                            : charge.created
                                ? new Date(charge.created * 1000).toLocaleString()
                                : '';
                        return {
                            total: invoice && invoice.total ? convertToAmount(invoice.total) : convertToAmount(charge.amount) || 0,
                            invoiceSubtotal: invoice && invoice.subtotal ? convertToAmount(invoice.subtotal) : 0,
                            invoiceTax: invoice && invoice.tax ? convertToAmount(invoice.tax) : 0,
                            appliedBalance: invoice && invoice.pre_payment_credit_notes_amount ? convertToAmount(invoice.pre_payment_credit_notes_amount) : 0,
                            startingBalance: invoice && invoice.starting_balance ? convertToAmount(invoice.starting_balance) : 0,
                            chargeAmount: convertToAmount(charge.amount) || 0,
                            amount_refunded: convertToAmount(charge.amount_refunded) || 0,
                            status: invoice && invoice.status ? invoice.status : charge.status || '',
                            created: createdDt, // Convert timestamp to human-readable date
                            description: invoice?.description || charge?.description || '',
                            isFrom: 'Stripe',
                            billing_reason: invoice.billing_reason,
                            line_items: invoice.line_items
                                ? invoice.line_items.map((item) => ({
                                    name: item.description, // Use description as item name
                                    qty: item.quantity, // Quantity
                                    amount: (item.amount / 100).toFixed(2), // Convert amount to dollars
                                    product: item.product
                                }))
                                : [], // Fallback to empty array if no line_items
                            metadata: invoice.metadata || null,
                        };
                    });

                    formattedTransactions.sort((a, b) => {
                        const dateA = new Date(a.created).getTime();
                        const dateB = new Date(b.created).getTime();
                        return dateA - dateB; // For ascending order (oldest first)
                    });
                    //setAllCharges(formattedTransactions)
                    setStripeTransactionsList(formattedTransactions);
                    setFilteredStripeTransactionsList(formattedTransactions);
                } else {
                    setAllCharges([])
                }
            })
            .catch((err) => {
                setIsLoading(false)
                console.error(err);
                alert("Error fetching charge data.", err);
            });
    }





    const toggleSelect = (id) => {
        setMembers((prevMembers) =>
            prevMembers.map((member) =>
                member.id === id
                    ? { ...member, selected: true } // Select the clicked member
                    : { ...member, selected: false } // Deselect all other members
            )
        );
    };
    const toggleStripeProductSelection = (id) => {
        const dataaa = stripeProductsList.map((product) =>
            product.id === id
                ? { ...product, selected: !(product.selected ?? false) } // toggle
                : product // keep others as-is
        )

        dispatch(setStripeProductsList(dataaa));
    };

    const removeItem = (e, { value }) => {
        setVisibleTags([...visibleTags].filter((tag) => tag.value !== value));
        setMembers(prevMembers =>
            prevMembers.map(member =>
                member.id === value ? { ...member, selected: false } : member
            )
        );
        setSelectedMember(null);
        setAccountHolderData(null);
        setMemberCreatedDate(null);
        setSelectedOption(null);
        setDateArray([]);
        setFilteredStripeTransactionsList([]);
        setStripeTransactionsList([]);
        setReportData([])
    };

    async function checkUserHasParent(accountHolderId) {
        try {
            const userDoc = await userDataService.getUser(accountHolderId);
            let parentuser = userDoc.data();
            if (parentuser) {
                setAccountHolderData(parentuser)
                setHasAccountHolder(true)
                const aDate = parentuser.contractStartDate ? parentuser.contractStartDate.toDate() : (parentuser.Created ? parentuser.Created.toDate() : parentuser.createdAt.toDate());

                const dateRanges = getYearlyDateRangesGroup(aDate);
                setDateArray(dateRanges);
                setMemberCreatedDate(parentuser.contractStartDate ? parentuser.contractStartDate.toDate() : null);

                if (parentuser.yearlyRequiredSpend) {
                    setTotalRequredSpend(parseFloat(parentuser.yearlyRequiredSpend))
                }
            } else {
                setHasAccountHolder(false)
            }
        } catch (error) {
            setHasAccountHolder(false)
        }
    }

    const handleApplyProducts = () => {
        const selectedProductIds = stripeProductsList
            .filter(product => product.selected)
            .map(product => product.id);
        if (selectedProductIds.length === 0) {
            setFilteredStripeTransactionsList(stripeTransactionsList);
        }
        const filteredTransactions = filterTransactionsByProducts(
            stripeTransactionsList,
            selectedProductIds
        );
        setFilteredStripeTransactionsList(filteredTransactions);
        setProductsPopupVisible(false);
    }

    const handleApplyMember = () => {
        setAccountHolderData(null);
        setMemberCreatedDate(null);
        setFilteredStripeTransactionsList([]);
        setStripeTransactionsList([]);
        setReportData([]);

        const selectedMembers = members.filter(member => member.selected);
        if (!selectedMembers.length) return;

        const member = selectedMembers[0];

        setVisibleTags([
            { value: member.id, children: member.displayname }
        ]);
        setPopupVisible(false);

        let createdDate = null;

        if (member.accountHolderId) {
            checkUserHasParent(member.accountHolderId);
            return; // parent flow handles its own fetch later
        } else {
            setHasAccountHolder(false);
            setAccountHolderData(null);

            createdDate = (member.contractStartDate && member.contractStartDate !== "")
                ? member.contractStartDate.toDate()
                : (member.Created ? member.Created.toDate() : member.createdAt.toDate());
            const dateRanges = getYearlyDateRangesGroup(createdDate);

            setDateArray(dateRanges);
            setSelectedOption(dateRanges[0]); // ✅ default to first year
            setMemberCreatedDate(member.contractStartDate ? member.contractStartDate.toDate() : null);

            if (member.yearlyRequiredSpend) {
                setTotalRequredSpend(parseFloat(member.yearlyRequiredSpend));
            }

            // ✅ AUTO FETCH USING FIRST YEAR GROUP
            const { start, end } = dateRanges[0].children;
            const fetchStart = (member && member.contractStartDate) ? formatDateLocal(member.contractStartDate.toDate()) : start;

            fetchPurchaseData(
                fetchStart,
                end,
                (data) => {
                    setStripeTransactionsList(data);
                    setFilteredStripeTransactionsList(data);
                },
                (err) => alert("Error Fetching Purchase data", err),
                member
            );
        }

        setSelectedMember(member);
    };


    const handleClear = () => {
        setSearchTerm('');
    };

    const handleSearchMember = event => {
        const value = event.target.value;
        setSearchMembers(value);
    };

    const handleSearchStripeProduct = event => {
        const value = event.target.value;
        setSearchedStripeProduct(value);
    };

    const openPopup = (event) => {
        // Calculate the position of the button
        const buttonRect = event.target.getBoundingClientRect();
        const buttonX = buttonRect.left + (buttonRect.width / 2);
        const buttonY = buttonRect.top + (buttonRect.height / 2);

        // Set the position of the popup relative to the button
        const popupWidth = 315;
        const popupHeight = 356;
        setPopupPosition({ x: buttonX, y: buttonY + 10 }); // Adjust 10px downward for better alignment

        // Show the popup
        setPopupVisibleDate(false);
        setPopupVisible(true);
        setPopupVisibleExport(false);
        setProductsPopupVisible(false);
    };
    const openProductsPopup = (event) => {
        // Calculate the position of the button
        const buttonRect = event.target.getBoundingClientRect();
        const buttonX = buttonRect.left + (buttonRect.width / 2);
        const buttonY = buttonRect.top + (buttonRect.height / 2);

        // Set the position of the popup relative to the button
        const popupWidth = 315;
        const popupHeight = 356;
        setPopupPosition({ x: buttonX, y: buttonY + 10 }); // Adjust 10px downward for better alignment

        // Show the popup
        setPopupVisibleDate(false);
        setPopupVisible(false);
        setProductsPopupVisible(true);
        setPopupVisibleExport(false)
    };
    const openExportPopup = (event) => {
        // Calculate the position of the button
        const buttonRect = event.target.getBoundingClientRect();
        const buttonX = buttonRect.left - 100 //+ (buttonRect.width / 2);
        const buttonY = buttonRect.top + (buttonRect.height / 2);
        setPopupPosition({ x: buttonX, y: buttonY + 10 }); // Adjust 10px downward for better alignment
        // Show the popup
        setPopupVisible(false);
        setPopupVisibleExport(true)
    };

    const handleExportChange = (option) => {
        setExportSelectedOption(option);
    };
    const handleCancelExport = () => {
        // Close the popup
        setPopupVisibleExport(false)
    };

    function onGenerateExportClick(from) {
        const dataArr = filteredstripeTransactionsList;
        if (dataArr.length > 0) {
            if (from == 2) {
            } else {
                generateTransactionsData(dataArr, exportSelectedOption, getProductName)
            }
        }
    }

    const openDatePopup = (event) => {
        // Calculate the position of the button
        const buttonRect = event.target.getBoundingClientRect();
        const buttonX = buttonRect.left + (buttonRect.width / 2);
        const buttonY = buttonRect.top + (buttonRect.height / 2);

        // Set the position of the popup relative to the button
        setPopupPosition({ x: buttonX, y: buttonY + 10 }); // Adjust 10px downward for better alignment

        // Show the popup
        setPopupVisible(false);
        setPopupVisibleExport(false)
        setPopupVisibleDate(true);
        setProductsPopupVisible(false);
    };
    const handleCancel = () => {
        // Close the popup
        setPopupVisible(false);
        setPopupVisibleDate(false);
        setProductsPopupVisible(false);
    };
    const handleDateApply = () => {

        if (!selectedOption || !selectedMember) {
            setPopupVisible(false);
            setPopupVisibleDate(false);
            return;
        };

        const startDate = selectedOption.children.start;
        const endDate = selectedOption.children.end;
        setStripeTransactionsList([]);
        setFilteredStripeTransactionsList([]);

        const fetchStart = (selectedMember && selectedMember.contractStartDate) ? formatDateLocal(selectedMember.contractStartDate.toDate()) : startDate;

        fetchPurchaseData(
            fetchStart,
            endDate,
            (data) => {
                setStripeTransactionsList(data);
                setFilteredStripeTransactionsList(data);
            },
            (err) => alert("Error Fetching Purchase data", err),
            selectedMember
        );

        setPopupVisible(false);
        setPopupVisibleDate(false);
    };



    const handleOptionClick = (group) => {
        // If the same group is clicked, it will be deselected
        setSelectedOption((prevOption) =>
            prevOption === group ? null : group
        );
    };
    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    function renderEventsOtherItem(item) {
        return (
            <div style={{}}>
                {
                    getChargeCardAmount(item) > 0 ?
                        <>
                            <div style={styles.productName}>Credit Card ${item.chargeAmount}</div>
                            {item.metadata.refunded ?
                                <div style={styles.productName}>Refund added in wallet balance</div> : <div />}
                        </> :
                        getMinimumspend(item) > 0 ?
                            <div style={styles.productName}>Use Minimum ${getMinimumspend(item)}</div> : <div />
                }
            </div>
        )
    }


    function renderRentalOtherItem(item) {
        return (
            <div style={{}}>
                {
                    getChargeCardAmount(item) > 0 ?
                        <div style={styles.productName}>Credit Card: ${getChargeCardAmount(item)}</div>
                        : <div />
                }
                {
                    getMinimumspend(item) > 0 ?
                        <div style={styles.productName}>Minimum: ${getMinimumspend(item)}</div>
                        : <div />
                }
                {
                    getPointspend(item) > 0 ?
                        <div style={styles.productName}>Driving Fleet: ${getPointspend(item)}</div>
                        : <div />
                }
            </div>
        )
    }

    // Total what actually counts toward the minimum, using the same
    // classification as calculateTotals on the server. This previously summed
    // invoice.total with no refund subtraction and no dues exclusion, so the
    // figure shown here was higher than the member's real spend and did not
    // agree with the API - refunded money and membership dues both inflated it.
    const grandTotal = filteredstripeTransactionsList.reduce(
        (sum, txn) => sum + classifyTransaction(txn).counted,
        0
    );


    function getProductName(productId) {
        if (!productId) return '';
        const product = stripeProductsList?.find(p => p.id === productId);
        return product?.name || '';
    }

    const formatDateLocal = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    function getBillingPeriod(selectedMember, dateArray, selectedOption) {
        if (!selectedMember || !dateArray || dateArray.length === 0) return null;

        // 1️⃣ Prefer explicitly selected group
        const group =
            selectedOption ??
            dateArray[0]; // fallback to first year group

        if (!group?.children?.start || !group?.children?.end) return null;


        return {
            startDate: formatDateLocal(new Date(group.children.start)),
            endDate: formatDateLocal(new Date(group.children.end)),
        };
    }


    const billingPeriod = selectedMember
        ? getBillingPeriod(selectedMember, dateArray, selectedOption)
        : null;


    const LineItemList = ({ lineItems }) => {
        if (lineItems && lineItems.length > 0) {
            // Calculate the total price of all line items
            return (
                <div>
                    {lineItems.map((item, index) => (
                        <div key={index}>
                            <div style={styles.productDetailsContainer}>
                                <div className="d-flex" style={{}}>
                                    <div style={styles.productName}>{item.name}</div>
                                    <div style={styles.productName2}>${parseIntoDollar(item.price)}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        } else {
            return <div>-</div>;
        }
    };

    const getDaysInPeriod = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);

        // Strip time to ensure the count is based purely on calendar days
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        const diffTime = Math.abs(endDate - startDate);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    };

    let remainingAnnualSpend = 0;
    let remainingSpendValue = 0;
    if (selectedMember && billingPeriod) {
        const startRef = selectedMember.contractStartDate ? selectedMember.contractStartDate.toDate() : new Date(billingPeriod.startDate);
        const days = getDaysInPeriod(startRef, billingPeriod.endDate);
        const annualRequirement = totalRequredSpend || 2000;
        const perDayRate = (annualRequirement / 365);
        remainingAnnualSpend = perDayRate * days;
        remainingSpendValue = remainingAnnualSpend - (grandTotal / 100);
        const totalJoinDate = selectedMember?.Created?.toDate() || selectedMember?.createdAt?.toDate();
    }
    return (
        <Layout>
            <div className={styles.content}>
                <div className={styles.breakFlex}>
                    {/* <Button shape="circular" appearance="primary" onClick={() => navigate(-1)}>Back</Button> */}
                </div>
                <div className={"d-flex justify-space-between"} style={{ marginTop: '10px' }}>
                    <div className={"d-flex"}>
                        <div style={{ marginTop: '8px' }}>
                            <FilterSVG />
                        </div>
                        <div className={'memberNameDiv'} onClick={openPopup}>
                            <span>Customer name</span>
                            <DownArowSVG />
                        </div>
                        <div className={'memberNameDiv'} onClick={openProductsPopup}>
                            <span>Product name</span>
                            <DownArowSVG />
                        </div>
                        <div className={'memberNameDiv'} onClick={openDatePopup}>
                            <span>1-Year Period</span>
                            <DownArowSVG />
                        </div>
                    </div>

                    <div className={"d-flex"}>
                        {<div className={"exportbtn"} onClick={openExportPopup}>
                            <span>Generate report</span>
                            <DownSmallArrow />
                        </div>}
                    </div>
                </div>

                <div style={{ marginTop: '10px' }}>
                    {dateTags.length !== 0 && (
                        <TagGroup role="list" aria-label="Dismiss example">
                            {dateTags.map((tag, index) => (
                                <Tag
                                    value={tag.value}
                                    key={tag.value}
                                    ref={index === 0 ? dateTagRef : null}
                                >
                                    {tag.children}
                                </Tag>
                            ))}
                        </TagGroup>
                    )}
                </div>
                <div style={{ marginTop: '10px' }}>

                    {visibleTags.length !== 0 && (
                        <TagGroup onDismiss={removeItem} aria-label="Dismiss example">
                            {visibleTags.map((tag, index) => (
                                <Tag
                                    dismissible
                                    dismissIcon={{ "aria-label": "remove" }}
                                    value={tag.value}
                                    key={tag.value}
                                    ref={index === 0 ? firstTagRef : null}
                                >
                                    {tag.children}
                                </Tag>
                            ))}
                        </TagGroup>
                    )}
                    {memberCreatedDate ? (<div style={{ marginLeft: '4px' }}>
                        Contract Start Date: {memberCreatedDate.toLocaleDateString()}
                    </div>) : null}

                </div>
                {filteredstripeTransactionsList.length > 0 && (
                    <>
                        <div style={{ marginLeft: '4px', marginTop: '4px' }}>
                            Total Amount: {parseIntoDollar(grandTotal)}
                        </div>
                        <div style={{ marginLeft: '4px', marginTop: '4px', color: 'orange', fontWeight: 'bold' }}>
                            Remaining Annual Spend: ${remainingAnnualSpend.toFixed(2)}
                        </div>
                        <div style={{ marginLeft: '4px', marginTop: '4px', color: remainingSpendValue < 2000 ? 'green' : 'red', fontWeight: 'bold' }}>
                            Remaining Spend: ${remainingSpendValue.toFixed(2)}
                        </div>
                        <div style={{ marginTop: '18px' }}>
                            <MinimumSpendBreakdown
                                transactions={filteredstripeTransactionsList}
                                apiTotal={grandTotal}
                                annualRequirement={remainingAnnualSpend}
                                periodStart={billingPeriod ? new Date(billingPeriod.startDate).toLocaleDateString() : null}
                                periodEnd={billingPeriod ? new Date(billingPeriod.endDate).toLocaleDateString() : null}
                                memberName={selectedMember ? `${selectedMember.firstName || ""} ${selectedMember.lastName || ""}`.trim() : ""}
                                memberNumber={selectedMember ? selectedMember.memberNumber : ""}
                            />
                        </div>
                    </>
                )}
                {selectedMember && billingPeriod && (
                    <div style={{ marginLeft: '4px', marginTop: '4px' }}>
                        Period: {billingPeriod.startDate} to {billingPeriod.endDate}
                    </div>
                )}

                {
                    accountHolderData && (
                        <Label style={{ marginLeft: '4px' }}>
                            Primary Account: {accountHolderData.firstName} {accountHolderData.lastName}
                        </Label>
                    )
                }
                <div className="table-layout3" style={{ border: isMobile ? 'none' : '' }}>
                    <Table aria-label="Table with cell actions"> {/* Set min-width here */}
                        {
                            isMobile ? (
                                null
                            ) : (

                                <TableHeader className="list-row2">
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableHeaderCell key={column.columnKey} style={{ width: column.width }}>
                                                <span className="listHeaderText">{column.label}</span>
                                            </TableHeaderCell>
                                        ))}
                                    </TableRow>
                                </TableHeader>

                            )
                        }
                        {selectedMember && filteredstripeTransactionsList.length > 0 && (
                            isMobile ? (
                                <tbody>
                                    {filteredstripeTransactionsList.map((txn, index) => {
                                        const isStripe = !(txn?.isFromClover ?? false);
                                        const invoice = txn?.invoice ?? txn.charge;
                                        const charge = txn?.charge ?? txn.invoice;
                                        let createdDt = '';
                                        if (isStripe) {
                                            if (invoice?.created) {
                                                createdDt = new Date(invoice.created * 1000);
                                            } else if (txn?.created) {
                                                createdDt = new Date(txn.created * 1000);
                                            }
                                        } else if (txn?.createdTime) {
                                            createdDt = new Date(txn.createdTime);
                                        }
                                        const formattedDate = createdDt ? createdDt.toLocaleString() : '';

                                        return (
                                            <tr key={index}>
                                                <td colSpan={11}>
                                                    <div className="charges-mobile-card">

                                                        {/* Source */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Source:</span>
                                                            <span className="charges-mobile-value">
                                                                {isStripe ? 'STRIPE' : 'CLOVER'}
                                                            </span>
                                                        </div>

                                                        {/* Date */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Date:</span>
                                                            <span className="charges-mobile-value">
                                                                {formattedDate}
                                                            </span>
                                                        </div>

                                                        {/* Reference */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Reference:</span>
                                                            <span className="charges-mobile-value">
                                                                {isStripe ? invoice?.number ?? invoice?.receipt_number : txn.id}
                                                            </span>
                                                        </div>

                                                        {/* Customer */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Customer:</span>
                                                            <span className="charges-mobile-value">
                                                                {isStripe
                                                                    ? invoice?.customer_name
                                                                    : `${txn.user?.firstName || ''} ${txn.user?.lastName || ''}`}
                                                            </span>
                                                        </div>

                                                        {/* Product */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Product:</span>
                                                            <span className="charges-mobile-value">
                                                                {isStripe
                                                                    ? invoice?.line_items ? invoice?.line_items
                                                                        ?.map(li => ((li?.product ?? "") === "") ? (li?.product_name ?? invoice?.description) : invoice.description) : invoice.description || ''
                                                                    : <LineItemList lineItems={txn.lineItems?.elements ?? []} />
                                                                }
                                                            </span>
                                                        </div>

                                                        {/* Subtotal */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Subtotal:</span>
                                                            <span className="charges-mobile-value">
                                                                {parseIntoDollar(isStripe ? (invoice.total_excluding_tax ?? invoice?.amount ?? 0) : txn.total - (txn.payments?.elements?.[0]?.taxAmount || 0))}
                                                            </span>
                                                        </div>

                                                        {/* Tax */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Tax:</span>
                                                            <span className="charges-mobile-value">
                                                                {parseIntoDollar(isStripe ? invoice.tax || ((invoice.total ?? invoice?.amount ?? 0.00) - (invoice.total_excluding_tax ?? invoice?.amount ?? 0.00)) : txn.payments?.elements?.[0]?.taxAmount || 0)}
                                                            </span>
                                                        </div>

                                                        {/* Total */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Total:</span>
                                                            <span className="charges-mobile-value">
                                                                {parseIntoDollar(isStripe ? invoice.total ?? invoice?.amount : txn.total)}
                                                            </span>
                                                        </div>

                                                        {/* Status */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Status:</span>
                                                            <span className="charges-mobile-value">
                                                                {isStripe
                                                                    ? (invoice?.status ?? charge?.status)
                                                                    : txn.paymentState}
                                                            </span>
                                                        </div>

                                                        {/* Type */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Type:</span>
                                                            <span className="charges-mobile-value">
                                                                {
                                                                    isStripe
                                                                        ? (invoice.billing_reason ?? 'Charge')?.replace(/_/g, ' ')
                                                                        : '-'
                                                                }
                                                            </span>
                                                        </div>

                                                        {/* Description */}
                                                        <div className="charges-mobile-field">
                                                            <span className="charges-mobile-label">Description:</span>
                                                            <span className="charges-mobile-value">
                                                                {isStripe
                                                                    ? invoice?.line_items?.[0]?.description || invoice?.description || ''
                                                                    : txn.note || ''}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>

                            ) : (
                                <TableBody>
                                    {filteredstripeTransactionsList.map((txn, index) => {
                                        const isStripe = !(txn?.isFromClover ?? false);
                                        const invoice = txn?.invoice ?? txn.charge;
                                        const charge = txn?.charge ?? txn.invoice;
                                        let createdDt = '';
                                        if (isStripe) {
                                            if (invoice?.created) {
                                                createdDt = new Date(invoice.created * 1000);
                                            } else if (txn?.created) {
                                                createdDt = new Date(txn.created * 1000);
                                            }
                                        } else if (txn?.createdTime) {
                                            createdDt = new Date(txn.createdTime);
                                        }
                                        const formattedDate = createdDt ? createdDt.toLocaleString() : '';

                                        return (
                                            <TableRow key={index}>
                                                {/* Source */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {isStripe ? 'STRIPE' : 'CLOVER'}
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Date */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {formattedDate}
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Reference */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {isStripe ? invoice?.number ?? invoice?.receipt_number : txn.id}
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Customer */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {isStripe ? invoice?.customer_name || '' : txn.user?.firstName || '' + ' ' + (txn.user?.lastName || '')}
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Product */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {isStripe
                                                            ? invoice?.line_items ? invoice?.line_items
                                                                ?.map(li => ((li?.product ?? "") === "") ? (li?.product_name ?? invoice?.description) : invoice?.description) : invoice?.description || ''
                                                            : <LineItemList lineItems={txn.lineItems?.elements ?? []} />
                                                        }
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Subtotal */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {parseIntoDollar(isStripe ? (invoice?.total_excluding_tax ?? invoice?.amount ?? 0) : txn.total - (txn.payments?.elements?.[0]?.taxAmount || 0))}
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Tax */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {parseIntoDollar(isStripe ? invoice?.tax || ((invoice?.total ?? invoice?.amount ?? 0.00) - (invoice?.total_excluding_tax ?? invoice?.amount ?? 0.00)) : txn.payments?.elements?.[0]?.taxAmount || 0)}
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Total */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {parseIntoDollar(isStripe ? invoice?.total ?? invoice?.amount : txn.total)}
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Status */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {isStripe
                                                            ? (invoice?.status ?? charge?.status)
                                                            : txn.paymentState}
                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Type */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {
                                                            isStripe
                                                                ? (invoice?.billing_reason ?? 'Charge')?.replace(/_/g, ' ')
                                                                : '-'
                                                        }

                                                    </TableCellLayout>
                                                </TableCell>

                                                {/* Description */}
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {isStripe
                                                            ? invoice?.line_items?.[0]?.description || invoice?.description || ''
                                                            : txn.note || ''}
                                                    </TableCellLayout>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>

                            )
                        )}
                        {
                            (isLoading || filteredstripeTransactionsList.length > 0 ? (
                                <div />
                            ) : (
                                <div className="nodatamain">
                                    <div>
                                        <NodataInfoSVG />
                                    </div>

                                    <div className="emptyTitleFont">
                                        {!selectedMember && accountHolderData
                                            ? "Access Denied"
                                            : "Report Table is Empty"}
                                    </div>

                                    <div className="emprtyDescFont">
                                        {!selectedMember && accountHolderData
                                            ? `Please select the primary account holder ${accountHolderData.firstName} ${accountHolderData.lastName} to view Minimum Spend.`
                                            : "Please select customer to view report."}
                                    </div>
                                </div>
                            ))
                        }
                    </Table>
                </div>
                <div style={{ marginTop: '10px', textAlign: 'center' }}>
                    {isLoading && <Spinner />} {/* Render loader if loading state is true */}
                </div>
                {popupVisible && (
                    <div className="popupmain"
                        style={{ position: 'absolute', top: popupPosition.y, left: popupPosition.x }}>
                        <CustomSearchInput2
                            value={searchMembers}
                            onChange={handleSearchMember}
                            onClick={handleClear}
                        />
                        <div className="popupMemberList">
                            {members
                                .filter(member => member.name.toLowerCase().includes(searchMembers))
                                .map((member) => (
                                    <div key={member.id}>
                                        <Label style={{ marginBottom: '4px' }} className="checkLabeldiv">
                                            <div
                                                onClick={() => toggleSelect(member.id)}
                                                style={{
                                                    cursor: 'pointer',
                                                    display: 'inline-flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                {member.selected ? (
                                                    <RadioSelected />  // Your checked SVG
                                                ) : (
                                                    <RadioUnSelected />  // Your unchecked SVG
                                                )}
                                                <div style={{ marginLeft: '8px' }}>{member.displayname}</div>
                                            </div>
                                        </Label>
                                    </div>
                                ))}
                        </div>
                        <div className="buttonContainer">
                            <button className="borderButton" onClick={handleCancel}>Cancel</button>
                            <button className="fillButton" onClick={handleApplyMember}>APPLY</button>
                        </div>
                    </div>
                )}
                {productsPopupVisible && (
                    <div
                        className="popupmain"
                        style={{
                            position: 'absolute',
                            top: popupPosition.y,
                            left: popupPosition.x,
                        }}
                    >
                        <CustomSearchInput2
                            value={searchedStripeProduct}
                            onChange={handleSearchStripeProduct}
                            onClick={handleClear}
                        />

                        <div className="popupMemberList">
                            {stripeProductsList
                                .filter((stripeProduct) =>
                                    stripeProduct.name
                                        .toLowerCase()
                                        .includes(searchedStripeProduct.toLowerCase())
                                )
                                .map((stripeProduct) => {

                                    const firebaseProduct = firebaseProducts.find(
                                        (fp) => fp.productId === stripeProduct.id
                                    );

                                    return (
                                        <div key={stripeProduct.id}>
                                            <Label style={{ marginBottom: '4px' }} className="checkLabeldiv">
                                                <div
                                                    onClick={() => toggleStripeProductSelection(stripeProduct.id)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                    }}
                                                >

                                                    {stripeProduct?.selected ? (
                                                        <CheckBoxChecked />
                                                    ) : (
                                                        <CheckBoxUnChecked />
                                                    )}

                                                    <div style={{ marginLeft: '8px' }}>
                                                        {stripeProduct.name}
                                                    </div>
                                                </div>
                                            </Label>
                                        </div>
                                    );
                                })}
                        </div>

                        <div className="buttonContainer">
                            <button className="borderButton" onClick={handleCancel}>
                                Cancel
                            </button>
                            <button className="fillButton" onClick={handleApplyProducts}>
                                APPLY
                            </button>
                        </div>
                    </div>
                )}


                {popupVisibleDate && (
                    <div className="popupmain" style={{
                        position: 'absolute',
                        top: popupPosition.y + 10,
                        left: popupPosition.x - 50,
                        height: undefined
                    }}>
                        {dateArray.map((tag, index) => {
                            // Check if this group (both halves) is selected
                            const isSelected = selectedOption === tag;

                            return (
                                <div
                                    key={tag.value}
                                    className={`todayBtn${isSelected ? " selected" : ""}`}
                                    onClick={() => handleOptionClick(tag)} // Handle group click
                                >
                                    {/* Display Grouping label */}
                                    <div>{`Grouping ${index + 1}`}</div>

                                    {/*/!* Display first half date range *!/*/}
                                    {/*<div>{`${formatDate(tag.children.firstHalf.start)} - ${formatDate(tag.children.firstHalf.end)}`}</div>*/}

                                    {/*/!* Display second half date range *!/*/}
                                    {/*<div>{`${formatDate(tag.children.secondHalf.start)} - ${formatDate(tag.children.secondHalf.end)}`}</div>*/}
                                    {`${formatDate(tag.children.start)} - ${formatDate(tag.children.end)}`}

                                </div>
                            );
                        })}
                        <div className="seperateLine"></div>
                        <div className="buttonContainer">
                            <button className="borderButton" onClick={handleCancel}>Cancel</button>
                            <button className="fillButton" onClick={handleDateApply}>APPLY</button>
                        </div>
                    </div>
                )}
                {popupVisibleExport && (
                    <div className="popupexport" style={{ position: 'absolute', top: popupPosition.y, right: 40 }}>
                        <div>
                            <div className="radioFrame" onClick={() => handleExportChange('CSV')}>
                                {exportSelectedOption === 'CSV' ? <RadioSelected /> : <RadioUnSelected />}
                                <div className="radioBtnText">CSV</div>
                            </div>
                            <div className="radioFrame" onClick={() => handleExportChange('PDF')}>
                                {exportSelectedOption === 'PDF' ? <RadioSelected /> : <RadioUnSelected />}
                                <div className="radioBtnText">PDF</div>
                            </div>
                            <div className="radioFrame" onClick={() => handleExportChange('Excel')}>
                                {exportSelectedOption === 'Excel' ? <RadioSelected /> : <RadioUnSelected />}
                                <div className="radioBtnText">Excel</div>
                            </div>
                        </div>
                        <div className="buttonContainer">
                            <button className="borderButton" onClick={handleCancelExport}>Cancel</button>
                            <button className="fillButton" onClick={() => {
                                onGenerateExportClick(1)
                            }}>EXPORT
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
}

export default TransactionsPage;

const useStyles = makeStyles({
    root: {
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "480px",
        backgroundColor: "#fff"
    },

    content: {
        ...shorthands.flex(1),
        ...shorthands.padding("16px"),
        display: "block",
        ...shorthands.gridArea("main")
    },

    breakFlex: {
        flexBasis: "100%",
        textAlign: "left"
    },
    popupmain: {
        width: '256px',
        height: '280px',
        position: 'relative',
        top: '124px',
        borderRadius: '10px',
        border: '1px solid #F4F4F4',
        background: '#FFF',
        boxShadow: '1px 1px 4px 0px rgba(89, 89, 89, 0.25)',
        padding: '16px',
        overflowY: 'auto',
    },
    popupMemberList: {
        paddingTop: '10px',
        maxHeight: '266px',
        overflowY: 'auto'
    },
    totalAmount: {
        marginTop: "16px",
        fontWeight: "bold"
    }
});


const styles = {
    productDetailsContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    imageContainer: {
        marginRight: 10,
    },
    productImage: {
        width: 62,
        height: 62,
        borderRadius: 5,
    },
    productName: {
        color: '#202020',
        fontFamily: 'Nunito Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px'
    },
    productName2: {
        marginLeft: '6px',
        color: '#202020',
        fontFamily: 'Nunito Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px'
    },
    productTotal: {
        marginTop: '2px',
        color: '#202020',
        fontFamily: 'Nunito Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '20px',
    },
    productPrice: {
        fontSize: 12,
        color: '#535353'
    },
    separator: {
        width: '100%',
        borderTop: '1px solid #ccc',
        marginTop: 10,
        marginBottom: 10
    }
};
const convertToAmount = (amount) => {
    return amount ? (amount / 100).toFixed(2) : null
}
const LineItemList = ({ lineItems }) => {
    if (lineItems && lineItems.length > 0) {
        return (
            <div>
                {lineItems.map((item, index) => (
                    <div key={index}>
                        <div style={styles.productDetailsContainer}>
                            <div className="d-flex" style={{}}>
                                <div style={styles.productName}>{item.name}</div>
                                <div style={styles.productName2}>${item.amount}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    } else {
        return <div>-</div>;
    }
};

//TODO issue when pass numGroups 2 need to check it shoud start from second year

function getYearlyDateRangesGroup(createdAt) {
    const createdDate = new Date(createdAt);
    const today = new Date();
    const dateRanges = [];

    const yearDiff = today.getFullYear() - createdDate.getFullYear();
    const totalGroups = Math.max(1, yearDiff + 1);

    for (let group = 0; group < totalGroups; group++) {
        let startDate, endDate;
        if (group === 0) {
            startDate = new Date(createdDate);
            endDate = new Date(createdDate.getFullYear(), 11, 31, 23, 59, 59);
        } else {
            startDate = new Date(createdDate.getFullYear() + group, 0, 1, 0, 0, 0);
            endDate = new Date(createdDate.getFullYear() + group, 11, 31, 23, 59, 59);
        }

        dateRanges.push({
            value: `Grouping_${group + 1}`,
            children: {
                start: startDate,
                end: endDate
            }
        });
    }

    return dateRanges;
}
